<template>
  <!-- only accessible by the link sent to invited employees -->
  <div>
    <div
      class="fullHeight is-flex is-flex-direction-column is-align-items-center is-justify-content-center"
    >
      <b-button 
          tag="router-link"
          to="/login"
          type="is-text"
          icon-left="chevron-left"
          class="mb-2 has-text-info">
          <strong>Back to login</strong>
      </b-button>
      <div class="bg">
        <p class="title is-4">Register</p>
        <form @keyup.enter="registerReq()">
          <b-field label="Email" label-position="on-border">
            <b-input v-model="email" placeholder="Email" :disabled="disabled" />
          </b-field>
          <b-field label="Practice ID" label-position="on-border">
            <b-input v-model="practiceID" placeholder="Practice ID" :disabled="disabled" />
          </b-field>
          <b-field label="First Name" label-position="on-border">
            <b-input v-model="first" placeholder="First Name" />
          </b-field>
          <b-field label="Last Name" label-position="on-border">
            <b-input v-model="last" placeholder="Last Name" />
          </b-field>
          <b-field label="Password" label-position="on-border">
            <b-input v-model="password" placeholder="Password" type="password" password-reveal />
          </b-field>
          <b-button @click="registerReq()" type="submit" class="is-success" icon-right="account-plus" :disabled="!canRegister">
            <strong>Register</strong>  
          </b-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "EmployeeRegister",
  computed: {
    canRegister() {
      if (this.email && this.password && this.practiceID && this.first && this.last) {
        return true
      } else return false
    },
    disabled() {
      // disable practice id and email, if the link they clicked included those params (which they should)
      if (this.$route.query.e && this.$route.query.p_id) {
        return true;
      } else {
        return false;
      }
    }
  },
  data() {
    // if passed in email, user those values
    let email = this.$route.query.e || "";
    let practiceID = this.$route.query.p_id || "";
    let first = this.$route.query.fn || "";
    let last = this.$route.query.ln || "";
    let title = this.$route.query.t || "";
    return {
      email,
      practiceID,
      first,
      last,
      password: "",
      title,
    };
  },
  methods: {
    async registerReq() {
      await this.register({
        email: this.email,
        password: this.password,
        existingPracticeID: this.practiceID,
        first: this.first,
        last: this.last,
        is_owner: false,
        title: this.title,
      });
    },
    ...mapActions({
      register: "auth/register"
    })
  }
};
</script>

<style lang="scss" scoped>
.bg {
  background-color: white;
  border-radius: 12px;
  padding: 1em;
}
.fullHeight {
  height: 100vh;
}
</style>